"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _shared = require("@clayui/shared");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Helpers = require("./Helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var ClayDatePickerDayNumber = function ClayDatePickerDayNumber(_ref) {
  var day = _ref.day,
    daysSelected = _ref.daysSelected,
    disabled = _ref.disabled,
    index = _ref.index,
    isFocused = _ref.isFocused,
    _onClick = _ref.onClick,
    range = _ref.range;
  var date = day.date,
    nextMonth = day.nextMonth,
    previousMonth = day.previousMonth;
  var _daysSelected = _slicedToArray(daysSelected, 2),
    startDate = _daysSelected[0],
    endDate = _daysSelected[1];
  var isStartAndEndDateRange = startDate.toDateString() !== endDate.toDateString() && isWithinInterval(date, daysSelected);
  var hasEndDateSelected = date.toDateString() === endDate.toDateString();
  var hasStartDateSelected = date.toDateString() === startDate.toDateString();
  return /*#__PURE__*/_react.default.createElement("div", {
    "aria-selected": isStartAndEndDateRange || hasStartDateSelected ? true : undefined,
    className: (0, _classnames.default)('date-picker-col', range && {
      'c-selected': isStartAndEndDateRange,
      'c-selected-end': hasEndDateSelected && !hasStartDateSelected,
      'c-selected-start': hasStartDateSelected && !hasEndDateSelected
    }),
    role: "gridcell"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": (0, _Helpers.setDate)(date, {
      hours: 12,
      milliseconds: 0,
      minutes: 0,
      seconds: 0
    }).toDateString(),
    className: (0, _classnames.default)('date-picker-date date-picker-calendar-item', {
      active: hasStartDateSelected || range && hasEndDateSelected,
      disabled: disabled,
      'next-month-date': nextMonth,
      'previous-month-date': previousMonth
    }),
    "data-index": index,
    disabled: disabled,
    onClick: function onClick() {
      return _onClick(date);
    },
    onKeyDown: function onKeyDown(event) {
      // When tabbing and selecting a DayNumber using
      // SPACE key the active state it's not being removed.
      // See https://github.com/liferay/clay/issues/3374 for more details.
      if (event.key === _shared.Keys.Spacebar) {
        event.preventDefault();
      }
    },
    onKeyUp: function onKeyUp(event) {
      if (event.key === _shared.Keys.Spacebar) {
        _onClick(date);
      }
    },
    tabIndex: isFocused ? undefined : -1,
    type: "button"
  }, date.getDate()));
};
function isWithinInterval(date, interval) {
  var _interval = _slicedToArray(interval, 2),
    start = _interval[0],
    end = _interval[1];
  var time = date.getTime();
  var startTime = start.getTime();
  var endTime = end.getTime();
  if (startTime > endTime) {
    return false;
  }
  return time >= startTime && time <= endTime;
}
var _default = exports.default = ClayDatePickerDayNumber;